import { z } from "zod";

/**
 * Search params `/konfiguracja/sfy` i `/konfiguracja/sfy/przeglad` — wspolne, zeby
 * przejscie konfiguracja ↔ przeglad nioslo wybrane polaczenie (producenta) w obie strony.
 */
export const sfySearchSchema = z.object({
	/** id polaczenia outbound (jedno polaczenie = jeden producent). */
	polaczenie: z.coerce.number().int().positive().optional().catch(undefined),
});

export type SfySearch = z.infer<typeof sfySearchSchema>;

/** Polaczenie z URL, jesli nadal istnieje; inaczej pierwsze z listy. */
export function resolveSfyConnectionId(
	fromUrl: number | undefined,
	connections: readonly { id: number }[],
): number | null {
	if (fromUrl != null && connections.some((c) => c.id === fromUrl)) return fromUrl;
	return connections[0]?.id ?? null;
}
